import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/saas.png'


const _hoisted_1 = {
  class: "rounded-3 p-4 text-center mb-4",
  style: {"background":"linear-gradient(164deg, #b95232 3.1%, #eb6d5c 99.22%)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("h2", {
      class: "fs-24 text-white mx-auto mb-5 text-center",
      style: {"max-width":"300px","line-height":"1.4"}
    }, " Have A Team More Than 10 Members? ", -1),
    _createElementVNode("a", {
      href: "#",
      class: "btn btn-dark fs-16 fw-medium rounded-3 py-2 px-3"
    }, " Upgrade Plans ", -1),
    _createElementVNode("div", { class: "text-center py-5 mt-4" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "saas"
      })
    ], -1)
  ]))]))
}